import { ArrayDataSource } from './BaseDataSources';
import { IPriceSource } from '../Interfaces';

export class PriceSourceSource extends ArrayDataSource<IPriceSource> {
  public constructor() {
    super('/datasource/pricesources');
  }
}